import axios from "axios";
//import { Toast, showToast, showTokenExpiryPopUp } from "../components/SweatAlert";
//import { useUser } from "../context/UserContext";
//import { useNavigate } from "react-router-dom";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  baseUrlImg: process.env.REACT_APP_Img_URL,
});
// const axiosInstance = axios.create({
//   baseURL: "https://uatapi.deepdms.net/api/",
//   baseUrlImg: "https://uatapi.deepdms.net",
// });

const getAuthHeaders = () => {
  const key = JSON.parse(localStorage.getItem("permissions"));
  return {
   'Authorization': `Bearer ${key?.token || ""}`,
    // 'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VySWQiOiIxIiwiRnVsbE5hbWUiOiJSZWhhbiIsImVtYWlsIjoicmVoYW5AZXhhbXBsZS5jb20iLCJEZWFsZXJJZCI6IiIsInJvbGUiOiJTYWxlcyBQZXJzb24iLCJSb2xlSWQiOiIxIiwibmJmIjoxNzY3NTg0NDcxLCJleHAiOjE3Njc2NzA4NzEsImlhdCI6MTc2NzU4NDQ3MSwiaXNzIjoiRE1TQVBJIiwiYXVkIjoiRE1TQ2xpZW50cyJ9.HJdFhWjV4d7W8yCODIQmfpohp2gaJqowzezrNWTb2ZY`,
    'Content-Type': "application/json",
  };
};

export const _api = async (method, url, data, callback) => {
  try {
    const config = {
      method,
      url,
      headers: getAuthHeaders(),
    };

    if (method === 'POST' || method === 'PUT') {
      // data.createdBy = 1;
      config.data = data;
    }

    const response = await axiosInstance(config);

    if (response && (response.status === 200 || response.status === 201)) {
      callback(response.data);
      return;
    }

    // fallback error
    callback({ isSuccess: false, message: "Something went wrong" });

  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Unknown error';

    callback({ isSuccess: false, message });
    console.error("API Error:", message);
  }
};



// _api('POST', 'PortalUserAPI/Add', postData, (res) => {
//   console.log(res);
// });

// _api('PUT', `PortalUserAPI/UpdatePortalUser/${id}`, updatedData, (res) => {
//   console.log(res);
// });

// _api('GET', 'PortalUserAPI/GetAllUsers', null, (res) => {
//   console.log(res);
// });

// _api('DELETE', `PortalUserAPI/DeleteUser/${id}`, null, (res) => {
//   console.log(res);
// });


export const _get = async (url, callback) => {
  //const { logoutUser } = useUser();
  //const navigate = useNavigate();
  if (url) {
    try {
      await axiosInstance
        .get(url, {
          headers:getAuthHeaders()
        })
        .then(function (response) {
          if (response && response.status === 200) {
            callback(response.data);
          } else {
            console.log("Something wents wrong");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401){
            //const is401 = showTokenExpiryPopUp();
            // if(is401){
            //   logoutUser();
            //   navigate('/sign-in')
            // }
           // showTokenExpiryPopUp(logoutUser, navigate)
          }
          console.log(error);
        });
    } catch (error) {
      callback(error);
    }
  }
};

export const _post = async (url, data, callback) => {
  try {
    await axiosInstance
      .post(url, data, {
        headers:getAuthHeaders()
      })
      .then(function (response) {
        if (response && (response.status === 200 || response.status === 201)) {
          callback(response.data);
        } else {
          console.log("Something wents wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (error) {
    callback(error);
  }
};

export const _put = async (url, data, callback) => {
  try {
    await axiosInstance
      .put(url, data, {
        headers:getAuthHeaders()
      })
      .then(function (response) {
        if (response && (response.status === 200 || response.status === 201)) {
          callback(response.data);
        } else {
          console.log("Something wents wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (error) {
    callback(error);
  }
};

export const _delete = async (url, id, callback) => {
  try {
    await axiosInstance
      .delete(url, {
        headers:getAuthHeaders()
      })
      .then(function (response) {
        if (response && response.status === 200) {
          callback(response.data);
        } else {
          console.log("Something wents wrong");
        }
      })
      .catch((error) => {
        error(error);
      });
  } catch (error) {
    callback(error);
  }
};